import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { usePeopleWithDisabilitiesChartsDataContext } from './hooks/usePeopleWithDisabilitiesChartsDataContext';

export const DisabilitiesPercentage = () => {
    const { chartData } = usePeopleWithDisabilitiesChartsDataContext();

    return (
        <Donut
            title={'Deficiências %'}
            subtitles={chartData?.disabilities?.map(
                (item) => item.description
            )}
            chartData={chartData?.disabilities || []}
            colors={
                defaultColors.slice(0, chartData?.disabilities?.length) ||
                []
            }
            height={400}
        />
    );
};
